import { useEffect, useRef, useState } from 'react';

export default function PageTransition({
  contentKey,
  children,
  scrollContainerId = 'main-content-scroll',
}) {
  const [displayedKey, setDisplayedKey] = useState(contentKey);
  const [displayedChildren, setDisplayedChildren] = useState(children);
  const [phase, setPhase] = useState('idle');
  const pendingRef = useRef(null);

  useEffect(() => {
    if (contentKey === displayedKey) return;

    pendingRef.current = { key: contentKey, children };

    setPhase('exit');

    const timer = setTimeout(() => {
      if (!pendingRef.current) return;

      setDisplayedChildren(pendingRef.current.children);
      setDisplayedKey(pendingRef.current.key);
      setPhase('enter');
      pendingRef.current = null;

      const scroller = document.getElementById(scrollContainerId);
      if (scroller) scroller.scrollTo({ top: 0, behavior: 'instant' });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setPhase('idle');
        });
      });
    }, 200);

    return () => clearTimeout(timer);
  }, [contentKey, displayedKey, children, scrollContainerId]);

  return (
    <div
      className={`h-full ${
        phase === 'exit'
          ? 'opacity-0 translate-y-3 blur-[2px] transition-all duration-200 ease-in'
          : phase === 'enter'
            ? 'opacity-0 -translate-y-3 blur-[2px] transition-none'
            : 'opacity-100 translate-y-0 blur-0 transition-all duration-300'
      }`}
      style={{
        transitionTimingFunction: phase === 'exit' || phase === 'enter' ? undefined : 'cubic-bezier(0.22,1,0.36,1)',
      }}
    >
      {displayedChildren}
    </div>
  );
}
